import { Section } from "@/components/common";
import { FRONT_OFFICE } from "@/lib/i18n";
import { PhotoGallery } from "./PhotoGallery";

export function RoPhotosTab({ ro, user }) {
  const isFront = FRONT_OFFICE.includes(user.role);
  const canTask = user.role !== "accountant";
  const own = (t) => user.role !== "mechanic" || t.mechanic_id === user.id;
  const meta = (extra) => ({ entity_type: "repair_order", entity_id: ro.id, ...extra });
  const tasks = ro.tasks.filter((t) => t.status !== "cancelled");
  return (
    <div className="space-y-4">
      <Section title="État à la réception" testId="ro-photos-reception">
        <PhotoGallery meta={meta({ phase: "reception" })} canUpload={isFront} testId="ro-reception-gallery" emptyText="Aucune photo de réception" />
      </Section>
      <Section title="Avant / après par tâche" testId="ro-photos-tasks">
        {!tasks.length && <p className="text-sm text-muted-foreground">Aucune tâche.</p>}
        {tasks.map((t) => (
          <div key={t.id} className="border-b border-border/50 py-3 first:pt-0 last:border-0 last:pb-0" data-testid={`ro-task-photos-${t.id}`}>
            <div className="mb-2 text-sm font-semibold">{t.description} <span className="text-xs font-normal text-muted-foreground">· {t.mechanic_name || "Non attribué"}</span></div>
            <div className="grid gap-4 sm:grid-cols-2">
              <div><div className="eyebrow mb-1.5">Avant travaux</div><PhotoGallery meta={meta({ task_id: t.id, phase: "before" })} canUpload={canTask && own(t)} testId={`task-${t.id}-before`} emptyText="—" /></div>
              <div><div className="eyebrow mb-1.5">Après travaux</div><PhotoGallery meta={meta({ task_id: t.id, phase: "after" })} canUpload={canTask && own(t)} testId={`task-${t.id}-after`} emptyText="—" /></div>
            </div>
          </div>
        ))}
      </Section>
      <Section title="Documents du dossier" testId="ro-photos-documents">
        <PhotoGallery meta={meta({ phase: "document" })} canUpload={canTask} allowPdf testId="ro-documents-gallery" emptyText="Aucun document (réception signée, devis papier, PV…)" />
      </Section>
    </div>
  );
}
